export function formatDate(rawDate: string): string {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const date = new Date(rawDate)

  return `${date.getUTCDate()} ${months[date.getUTCMonth()]} ${date.getUTCFullYear()}`
}

export function validateOrderId(orderNumber: string): string | null {
  if (!/^[a-zA-Z0-9]+$/g.test(orderNumber)) {
    return 'Please make sure you enter a valid order number.'
  }

  return null
}

const CommonReasons = {
  wrongSizeTooSmall : 'Wrong size - too small',
  wrongSizeTooLarge : 'Wrong size - too large',
  wrongItem         : 'Wrong item was ordered',
}

export const DenyReasons = {
  missingParts   : 'Missing parts or accessories',
  productDamaged : 'Product arrived damaged',
  itemDefective  : 'Item defective or doesn\'t work',
}

export const ReturnReasons = {
  ...CommonReasons,
  noLongerNeeded : 'No longer needed',
  lateArrival    : 'Item arrived too late',
  unableToCancel : 'I could not cancel the order',
  ...DenyReasons,
}
export const ExchangeReasons = {
  ...CommonReasons,
  ...DenyReasons,
}
